<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Users
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-select
              v-model="role"
              label="Role"
              :items="roles"
              prepend-icon="mdi-card-account-details"
              @change="getDataFromApi()"
              item-text="name"
              item-value="id"
              single-line
              hide-details
              clearable
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small 
                class="mr-2"
                @click="toggleDeleteUser(item)">
                mdi-delete
              </v-icon>
              <v-icon
                small 
                class="mr-2"
                @click="loginAsUser(item)">
                mdi-login
              </v-icon>
            </template>
          </v-data-table>
        </v-card>

        <v-dialog v-model="dialogAdd" max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5" v-if="addOrEdit == 'add'">Add New User</span>
              <span class="text-h5" v-if="addOrEdit == 'edit'">Edit User {{newuser.id}}</span>
            </v-card-title>

            <v-card-text>
              <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select
                    
                      multiple
                      chips
                      v-model="newuser.roles"
                      label="Role"
                      :items="roles"
                      item-text="name"
                      item-value="name"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newuser.first_name"
                      label="First name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newuser.last_name"
                      label="Last name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newuser.email"
                      label="Email"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newuser.password"
                      label="password"
                      type="text"
                      append-icon="mdi-calculator"
                      @click:append="generatePassword"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select
                      v-model="newuser.status"
                      label="Status"
                      :items="statuses"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </v-col>
                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deletedialog" style="max-width:600px">
            <v-card v-if="accountToDelete">
                <v-card-title>
                    Are you sure you would like to delete this account?
                </v-card-title>
                <v-card-text>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Roles</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ accountToDelete.id }}</td>
                          <td>{{ accountToDelete.first_name }} {{ accountToDelete.last_name }}</td>
                          <td>{{ accountToDelete.email }}</td>
                          <td>{{ accountToDelete.roles.join() }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="deleteUser">Confirm Deletion</v-btn>
                    <v-btn color="primary" @click="deletedialog=false">Cancel and Return</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      users: Array,
      roleList: Array,
      baseurl: String,
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            role: '',
            roles: [],
            list: [],
            keyword: "",
            location: "",
            category: "",
            total: this.users.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'First Name', value:'first_name'},
              { text: 'Last Name', value:'last_name'},
              { text: 'Email', value:'email'},
              { text: 'Newsletter', value:'newsletter'},
              { text: 'Social', value:'social_type'},
              { text: 'Role', value:'roles'},
              { text:'Action', value:'action'}

            ],
            newuser: {
              first_name:"",
              last_name: "",
              email: "",
              password:"",
              role:"",
              status:1
            },
            dialogAdd: false,
            dialogDelete: false,
            addOrEdit: 'add',
            errors:false,
            accountToDelete: null,
            deletedialog:false,
            statuses: [{"text":"Active","value":1},{"text":"Disabled","value":0}]
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.users));
      this.roles = JSON.parse(JSON.stringify(this.roleList));
    },
    methods: {
    toggleDeleteUser(item) {
      this.accountToDelete = item;
      this.deletedialog = true;
    },
    deleteUser(item) {
      if (this.accountToDelete)
      {
        
        axios.get("/admin/deleteuser/"+this.accountToDelete.id).then((response) => {
          console.log('admindeleteuser response',response)
          this.getDataFromApi()
          this.deletedialog = false;
          this.accountToDelete = null;
        });
      
      }
    },
    loginAsUser(i)
    {
      axios.post("/admin/users/loginasuser",i).then((response) => {
        window.open(this.baseurl);
      });
    },
      edit(i) {
        this.newuser = i;
        this.addOrEdit = 'edit';
        this.dialogAdd = true;
      },
      generatePassword() {
        this.newuser.password= [...window.crypto.getRandomValues(new Uint32Array(passwordLength))]
                .map(x => passwordChars[x % passwordChars.length])
                .join('')
      },
      addNew(){
        Object.keys(this.newuser).forEach(key => {
          this.newuser[key] = "";
        });
        this.generatePassword();
        this.dialogAdd = true;
        this.addOrEdit = 'add';
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/users/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },

      saveAddDialog () {
        if (this.addOrEdit == 'add')
        {
          this.loadingAdd=true;
          this.errors=false;
            console.log('adding user',this.newuser)
            axios.post("/admin/users/add",this.newuser).then((response) => {
              if (response.status == '200' && response.data == true)
              {
                this.dialogAdd = false;
                this.getDataFromApi();
              }
              else
                alert('Add failed');
              
                console.log('add response',response)
              this.loadingAdd = false;
            }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        }
        else
        {
          this.loadingAdd = true;
          this.errors=false;
          console.log('editing user',this.newuser)
          axios.post("/admin/users/edit",this.newuser).then((response) => {
              if (response.status == '200' && response.data == true)
              {
                this.dialogAdd = false;
                this.getDataFromApi();
              }
              else
                alert('Add failed');
              
                console.log('edit response',response)
              this.loadingAdd = false;
            }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        }
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  